import ReferralSpecialities from 'pages/settings/components/ReferralSpecialities'
import React from 'react'
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import { path } from 'utils/const'

const LabSupport = lazy(() => import('pages/lab-support'))
const LabTracking = lazy(() => import('pages/lab-tracking'))
const MedicalNoteTracking = lazy(() => import('pages/medical-note'))
const PhysioPanel = lazy(() => import('pages/physio-panel'))
const PhysioPipeline = lazy(() => import('pages/physio-submissions'))
const PatientPHD = lazy(() => import('pages/patient'))
const Templates = lazy(() => import('pages/templates/Templates'))
const MedicalTab = lazy(() => import('pages/medical-tab/medicalTab'))
const MedicalNotesTab = lazy(() => import('pages/medical-notes-tab/MedicalNotesTab'))

const Archive = lazy(() => import('MentalHealth/pages/archive'))
const ActiveChat = lazy(() => import('MentalHealth/pages/ActiveChats'))
const Dashboard = lazy(() => import('pages/dashboard'))
const Logs = lazy(() => import('pages/PatientLogs/Logs'))
const DashboardLogs = lazy(() => import('pages/DashboardLogs/Logs'))
const ChooseProfile = lazy(() => import('pages/dashboard/chooseProfile'))
const AdminDashboard = lazy(() => import('pages/dashboard/adminDashboard'))
const Counsellors = lazy(() => import('MentalHealth/pages/Counsellors/index'))
const EditCounselor = lazy(() =>
  import('MentalHealth/pages/Counsellors/views/EditCounselor'),
)
const Calendar = lazy(() =>
  import('MentalHealth/pages/Calendar/AdminCalendar/index'),
)
const CannedMessages = lazy(() =>
  import('MentalHealth/pages/CannedMessages/index'),
)
const Patient = lazy(() => import('MentalHealth/pages/Patient/index'))

const UserProfile = lazy(() => import('MentalHealth/pages/Profile/index'))
const Rotas = lazy(() => import('MentalHealth/pages/Rotas/index'))
const PrescriptionTracking = lazy(() => import('pages/prescription-tracking'))

export const adminRoutes = [
  {
    path: '/choose-profile',
    element: <ChooseProfile />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/admin-dashboard',
    element: <AdminDashboard />,
  },
  {
    path: '/counselors',
    children: [
      {
        index: true,
        element: <Counsellors />,
      },
      {
        path: '/counselors/:counselorId',
        element: <EditCounselor />,
      },
    ],
  },
  {
    path: '/active-chats',
    element: <ActiveChat />,
  },
  {
    path: '/calendar',
    element: <Calendar />,
  },
  {
    path: '/rotas',
    element: <Rotas />,
  },
  {
    path: '/archive-chats',
    element: <Archive />,
  },
  {
    path: '/profile',
    element: <UserProfile />,
  },
  {
    path: '/settings',
    element: <CannedMessages />,
  },
  {
    path: '/patient/:patientId',
    element: <Patient />,
  },
  {
    path: '/templates',
    element: <Templates />,
  },
  {
    path: '/referral-specialities',
    element: <ReferralSpecialities />,
  },
  {
    path: '/patient',
    element: <PatientPHD />,
  },
  {
    path: '/patient/:patientId/:conversation',
    element: <PatientPHD />,
  },
  {
    path: '/prescription-tracking',
    element: <PrescriptionTracking />,
  },
  {
    path: '/lab-tracking',
    element: <LabTracking />,
  },
  {
    path: '/medical-note',
    element: <MedicalNoteTracking />,
  },
  {
    path: '/physio-panel',
    element: <PhysioPanel />,
  },
  {
    path: '/physio-submissions',
    element: <PhysioPipeline />,
  },
  {
    path: '/lab-support',
    element: <LabSupport />,
  },
  {
    path: '/logs/patients/:patientID',
    element: <Logs />,
  },
  {
    path: '/logs/events',
    element: <DashboardLogs />,
  },
  {
    path: '/medical-tab/:patientId',
    element: <MedicalTab />,
  },
  {
    path: '/medical-notes-tab/:patientId',
    element: <MedicalNotesTab />,
  },
  {
    path: '*',
    element: <Navigate to="/choose-profile" replace />,
  },
]
